import { useState } from 'react';

interface NavigationProps {
  isScrolled: boolean;
  scrollToSection: (id: string) => void;
}

const Navigation = ({ isScrolled, scrollToSection }: NavigationProps) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const navItems = [
    { id: 'top', label: 'TOP' },
    { id: 'company', label: '受け入れ企業の方' },
    { id: 'support-org', label: '登録支援機関・人材紹介会社の方' },
    { id: 'pricing', label: '報酬額' },
    { id: 'office', label: '事務所概要' },
    { id: 'contact', label: 'お問合せ' }
  ];

  const handleNav = (id: string) => {
    scrollToSection(id);
    setMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled ? 'bg-white border-b border-blue-100' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8 py-3 md:py-4">
        <div className="flex items-center justify-between max-w-7xl mx-auto">
          {/* ロゴ */}
          <div className="flex items-center gap-3">
            <div className={`w-px h-10 md:h-12 transition-colors ${isScrolled ? 'bg-[#1a3a5c]' : 'bg-blue-300/70'}`}></div>
            <div>
              <a
                href="https://mkhoumujimu-visa.readdy.co/"
                target="_blank"
                rel="noopener noreferrer"
                className={`block text-[10px] md:text-xs tracking-[0.15em] md:tracking-[0.2em] font-bold mb-0.5 transition-colors hover:underline cursor-pointer whitespace-nowrap ${isScrolled ? 'text-[#1a3a5c]' : 'text-blue-200'}`}
              >
                行政書士ＭＫ法務事務所ビザ総合サイト
              </a>
              <h1 className={`text-sm md:text-base font-bold tracking-wider transition-colors ${isScrolled ? 'text-slate-800' : 'text-white'}`}
                style={{ fontFamily: "'Noto Serif JP', serif" }}>
                特定技能ビザ申請サポート大阪
              </h1>
            </div>
          </div>

          {/* デスクトップナビ */}
          <div className="hidden lg:flex items-center gap-6 xl:gap-8">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => handleNav(item.id)}
                className={`text-xs font-medium tracking-wider transition-all duration-200 whitespace-nowrap cursor-pointer border-b border-transparent hover:border-current pb-0.5 ${
                  isScrolled ? 'text-slate-600 hover:text-[#1a3a5c]' : 'text-white/85 hover:text-white'
                }`}
              >
                {item.label}
              </button>
            ))}
          </div>

          {/* ハンバーガーボタン */}
          <button
            className={`lg:hidden w-10 h-10 flex flex-col items-center justify-center gap-1.5 cursor-pointer flex-shrink-0 ${isScrolled ? 'text-[#1a3a5c]' : 'text-white'}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="メニュー"
          >
            <span className={`block w-6 h-0.5 bg-current transition-all duration-300 ${menuOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
            <span className={`block w-6 h-0.5 bg-current transition-all duration-300 ${menuOpen ? 'opacity-0' : ''}`}></span>
            <span className={`block w-6 h-0.5 bg-current transition-all duration-300 ${menuOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
          </button>
        </div>
      </div>

      {/* モバイルメニュー */}
      <div className={`lg:hidden bg-white border-t border-blue-100 overflow-hidden transition-all duration-300 ${menuOpen ? 'max-h-96' : 'max-h-0'}`}>
        <div className="px-4 py-2">
          {navItems.map((item) => (
            <button
              key={item.id}
              onClick={() => handleNav(item.id)}
              className="w-full text-left px-4 py-3 text-sm font-medium text-slate-700 hover:text-[#1a3a5c] hover:bg-blue-50 transition-colors cursor-pointer border-b border-slate-100 last:border-0 whitespace-nowrap"
            >
              {item.label}
            </button>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
